import {Outlet, useNavigate} from "react-router-dom"
import {useDeleteMessageFlowMapper, useFindAllMessageFlowMappers} from "hooks/query/mqtt-connectivity-query"
import {NotificationType, showNotification} from "common/Notification"

export const MessageRouteListView = () => {
    const navigate = useNavigate()
    const {data: routes} = useFindAllMessageFlowMappers()
    const deleteMutate = useDeleteMessageFlowMapper()

    const deleteMapper = (id: string) => {
        if (!window.confirm("삭제하시겠습니까?")) return
        deleteMutate.mutate(id, {
            onSuccess: () => {
                showNotification("Message Route를 삭제했습니다", NotificationType.SUCCESS)
            },
            onError: () => showNotification("Message Route를 삭제하지 못했습니다")
        })
    }
    return (
        <div className="main-body">
            <div className="level mb0">
                <div className="level-left">
                    <h5 className="is-size-5 has-text-weight-bold ml5">Message Route</h5>
                </div>
                <div className="level-right">
                    <div className="level-item input-search-box3 mt5">
                        <div className="btn-search">
                            <i className="fa fa-search"/>
                        </div>
                        <input className="input" type="text" placeholder="검색"/>
                    </div>
                </div>
            </div>

            <div className="main-panel">
                <div className="level">
                    <div className="level-left">
                        <div className="level-item ml20 mt10 is-size-85">
                        </div>
                    </div>
                    <div className="level-right">
                        <a className="button is-purple2 is-size-85" onClick={() => navigate("register")}>
                            <span className="icon is-small">
                                <i className="fas fa-plus"/>
                            </span>
                            <span>Message Route 추가</span>
                        </a>
                    </div>

                </div>

                {/*<div className="grid-table grid-7 mt5">*/}
                <header className="flex flex-row text-gray-400 border-b border-b-gray-200 text-xs items-center">
                    <div className={`${ItemClassName} basis-1/12`}>NO</div>
                    <div className={`${ItemClassName} basis-2/12`}>형태</div>
                    <div className={`${ItemClassName} basis-2/12`}>Route 이름</div>
                    <div className={`${ItemClassName} basis-2/12`}>분류키(App ID/Header Key)</div>
                    <div className={`${ItemClassName} basis-4/12`}>Kafka Topic</div>
                    <div className={`${ItemClassName} basis-1/12`}>관리</div>
                </header>

                {routes?.map((mapper, idx) => {
                    return (
                        <main className={ItemContainerClassName}
                              key={mapper.id}>
                            <div className={`${ItemClassName} basis-1/12`}>{idx + 1}</div>
                            <div className={`${ItemClassName} basis-2/12`}>{mapper.processorType}</div>
                            <div className={`${ItemClassName} basis-2/12`}>{mapper.name}</div>
                            <div className={`${ItemClassName} basis-2/12`}>{mapper.headerKey}</div>
                            <div className={`${ItemClassName} basis-4/12`}>{mapper.topic}</div>
                            <div className={`${ItemClassName} basis-1/12`}>
                                <button className="button is-small is-link"
                                        onClick={() => navigate(`/message-route/list/update/${mapper.id}`)}>수정
                                </button>
                                <button className="button is-small is-danger ml-2"
                                        onClick={() => deleteMapper(mapper.id)}>삭제
                                </button>
                            </div>
                        </main>
                    )
                })}

                {/*</div>*/}
                <Outlet/>
            </div>
        </div>
    )
}

const ItemClassName = "text-center pt-5 pb-5"
const ItemContainerClassName = "flex flex-row text-gray-800 border-b border-b-gray-200 text-sm items-center"